export interface NodeProp {
  data: any;
  parent: any;
  children: any[];
}
export class Node<T> {
  data: any = {};
  parent: any = {};
  children: T[] = [];
  constructor(data: any) {
    this.data = data;
    this.parent = null;
    this.children = [];
  }
}
